import { BUTTON_TYPES, OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPencil, faStar, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FormaContactoReadingDtoProps } from "api/DTOs/FormaContactoReadingDto"
import { FORMAS_DE_CONTACTO_ICONS } from "features/Contactos/constants"
import { useTranslation } from "react-i18next"

const FormaContactoItem = ({
  formaContacto,
  edit,
  markAsPrincipal,
  remove,
}: {
  formaContacto: FormaContactoReadingDtoProps
  edit: (formaContacto: FormaContactoReadingDtoProps) => void
  markAsPrincipal: (formaContacto: FormaContactoReadingDtoProps) => void
  remove: (id: string) => void
}) => {
  const { t } = useTranslation()
  const { id, contacto, tipoFormaContacto } = formaContacto

  return (
    <div
      className='tw-h-11 tw-gap-2 tw-w-full tw-px-3 tw-flex tw-flex-row tw-bg-neutral-10 tw-border tw-border-neutral-25 tw-rounded tw-justify-between tw-items-center'
      key={id}
    >
      {tipoFormaContacto ? (
        <FontAwesomeIcon
          icon={FORMAS_DE_CONTACTO_ICONS?.[tipoFormaContacto]}
          className='tw-text-primary tw-h-5 tw-w-5'
        />
      ) : (
        <div className='tw-h-5- tw-w-5' />
      )}
      <div className='tw-flex-row tw-flex tw-justify-end tw-items-center tw-w-10/12 tw-gap-2'>
        <div
          className={`tw-text-sm tw-truncate ${
            contacto ? "tw-text-info-100" : "tw-text-neutral-75"
          }`}
        >
          {contacto || `${t("contactos.editar.notComplet")}`}
        </div>
        {contacto && (
          <OptionsMenuStorybook
            id={`${id}`}
            items={[
              {
                title: `${t("contactos.editar.editFormContact")}`,
                hasRedirect: false,
                icon: faPencil,
                action: () => edit(formaContacto),
              },
              {
                title: `${t("contactos.editar.markPrincipal")}`,
                hasRedirect: false,
                icon: faStar,
                action: () => markAsPrincipal(formaContacto),
                show: !formaContacto.principal,
              },
              {
                title: `${t("contactos.editar.deleteFormContat")}`,
                hasRedirect: false,
                icon: faTrashCan,
                className: "!tw-text-danger",
                action: () => formaContacto.id && remove(formaContacto.id),
              },
            ]}
            buttonClassName='!tw-border-none !tw-bg-neutral-10 !tw-shadow-none'
            typeButton={BUTTON_TYPES.NONE}
            position='right'
          />
        )}
      </div>
    </div>
  )
}

export default FormaContactoItem
